import { Route, Routes, useLocation } from "react-router-dom";
import Login from "../features/login/Login";
import ForgetPassword from "../features/login/ForgetPassword";
import OtpVerification from "./../features/login/OtpVerification";
import ResetPassword from "./../features/login/ResetPassword";
import PrivateRoute from "./PrivateRoute";
import Dashboard from "../features/dashboard/DashboardData";
import Company from "../features/company/Companies";
import ViewCompany from "../features/company/ViewCompany";
import EditCompany from "../features/company/EditCompany";
import User from "../features/user/User";
import Debtors from "../features/user/Debtors";
import Sidebar from "../component/Sidebar";
import Teacher from "../features/teacher/Teacher";
import ViewUser from "../features/user/ViewUser";
import Adduser from "../features/user/Adduser";
import WalletHistory from "../features/user/WalletHistory";
import Events from "../features/event/Events";
import ViewEvent from "../features/event/ViewEvent";
import ViewTeacher from "../features/teacher/ViewTeacher";
import AddTeacher from "../features/teacher/AddTeacher";
import EditTeacher from "../features/teacher/EditTeacher";
import AddEvent from "../features/event/AddEvent";
import Membership from "../features/membership/Membership";
import ViewMembership from "../features/membership/ViewMembership";
import AddMembership from "../features/membership/AddMembership";
import Class from "../features/class/Class";
import InactiveClass from "../features/class/InactiveClass";
import AddClass from "../features/class/AddClass";
import Register from "../features/register/Register";
import ViewRegister from "../features/register/ViewRegister";
import AddRegister from "../features/register/AddRegister";
import EditRegister from "../features/register/EditRegister";
import Booking from "../features/booking/Booking";
import BookingDetail from "../features/booking/BookingDetail";
import { AnimatePresence } from "framer-motion";
import { useLayoutEffect } from "react";
import AccountDeletion from "../features/accountDeleteionRequest/AccountDeletion";
import ViewAccountDeletion from "../features/accountDeleteionRequest/ViewAccountDeletion";
import AnonymizedUser from "../features/anonymizedUser/UserList";
import ViewImportExport from "../features/importExportData/ViewImportExport";
import SchoolList from "../features/school/SchoolList";
import AddSchool from "../features/school/AddSchool";
import SchoolDetail from "../features/school/SchoolDetail";
import ClassDetail from "../features/class/ClassDetail";
import AreaCodeList from "../features/areacode/AreaCodeList";
import AddAreaCode from "../features/areacode/AddAreaCode";
import Student from "../features/student/Student";
import ViewStudent from "../features/student/ViewStudent";
import EventBooking from "../features/booking/EventBookings";
import Sizes from "../features/sizes/Sizes";
import AddSize from "../features/sizes/AddSize";
import EarningByMembership from "../features/payment/EarningByMembership";
import EarningByTeacher from "../features/payment/EarningByTeacher";
import FinanceManagement from "../features/payment/FinanceManagement";
import TeacherEarning from "../features/payment/TeacherEarning";
import FeeSettings from "../features/payment/FeeSettings";
import TeacherEarningStudentDetails from "../features/payment/TeacherEarningStudentDetails";
import Refund from "../features/payment/Refund";
import AddPaymentDetail from "../features/payment/AddPaymentDetail";
import AddAccount from "../features/payment/AddAccount";
import TeacherEarningDetails from "../features/payment/TeacherEarningDetails";
import EventTypes from "../features/eventType/EventTypes";
import AddEventType from "../features/eventType/AddEventType";
import Discipline from "../features/discipline/Discipline";
import AddDiscipline from "../features/discipline/AddDiscipline";
import ManageSubAdmin from "./../features/subAdmin/ManageSubAdmin";
import AddSubadmin from "../features/subAdmin/AddSubadmin";
import ViewSubadmin from "./../features/subAdmin/ViewSubadmin";
import ChangePassword from "../features/login/ChangePassword";
import ChangeEmail from "../features/login/ChangeEmail";
import Settings from "../features/settings/SettingsForm";
import EditStudent from "../features/student/EditStudent";
import Wallet from "../features/user/Wallet";
import CancelledClass from "../features/class/CancelledClass";
import AddStudent from "../features/student/AddStudent";
import StudentToTeacher from "../features/student/StudentToTeacher";
import CancelledEarning from "../features/payment/CancelledEarning";
import Consent from "../features/consent/Consent";
import AddConsent from "../features/consent/AddConsent";
import EditConsent from "../features/consent/EditConsent";
import TNCList from "../features/tnc/TNCList";
import AddTnc from "../features/tnc/AddTnc";
import EditRequest from "../features/editRequest/EditRequest";
import EditUserRequest from "../features/editRequest/user/EditUserRequest";
import EditUserConsentRequest from "../features/editRequest/user/EditUserConsentRequest";
import NewsLetter from "../features/newsletter/NewsLetter";
import NewsletterDetail from "../features/newsletter/NewsletterDetail";
import AddNewsletter from "../features/newsletter/AddNewsletter";
import ImportExportStudent from "./../features/importExportData/ImportExportStudent";
import ImportExportUser from "./../features/importExportData/ImportExportUser";
import ImportExportRequest from "./../features/importExportData/ImportExportRequest";
import ImportExportLogs from "./../features/importExportData/ImportExportLogs";
import AllStudentListings from "../features/register/AllStudentListings";
import { useEffect } from "react";
import MailingList from "../features/mailing/MailingList";
import SmsListing from "../features/manageSMS/SmsListing";
import AddSMS from "../features/manageSMS/AddSMS";
import SmsDetails from "../features/manageSMS/SmsDetails";
import NotFound from '../features/NotFound';
import EmailTemplates from '../features/emailTemplates/List';
import EditTemplate from '../features/emailTemplates/EditTemplate';
import MasterEmailTemplates from '../features/emailTemplates/MasterEmailList';
import EditMasterTemplate from '../features/emailTemplates/EditMasterTemplate';
import ProtectedRoute from './ProtectedRoute';
import PlansAndAddons from '../features/subscription/PlansAndAddons';
import SubscriptionSuccess from '../features/subscription/SubscriptionSuccess';
import SubscriptionGuard from '../component/SubscriptionGuard';

const companies = localStorage.getItem("companies") && localStorage.getItem("companies") !== "undefined" ? JSON.parse(localStorage.getItem("companies")) : [];
const isCompany = companies.length > 0 ? 0 : 1;




const Routers = [
  {
    path: "/404",
    element: NotFound,
    hidden: true,
    name: "404",
    subname: "404",
    subPath:['404'],
  },
  {
    path: "/dashboard",
    element: Dashboard,
    hidden: false,
    name: "DASHBOARD",
    subname: "dashboard",
    subPath:['dashboard'],
    inactiveImage: "assets/images/import-export-data.png",
    activeImage: "assets/images/import-export-data-selected.png",
  },
  {
    path: "/company",
    element: Company,
    hidden: false,
    name: "COMPANIES",
    subname: "company",
    subPath:['company'],
    inactiveImage: "assets/images/class-schedules.png",
    activeImage: "assets/images/class-schedules-selected.png",
  },
  {
    path: "/bookings",
    element: Booking,
    hidden: false,
    name: "BOOKINGS",
    subname: "booking",
    subPath:['bookings', 'register', 'event-bookings'],
    inactiveImage: "assets/images/bookings.png",
    activeImage: "assets/images/bookings-selected.png",
    subElements:[
                  {
                    path: "/bookings",
                    subname: "booking",
                    subPath: ['bookings', 'event-bookings'],
                    name: "Bookings",
                  },
                  {
                    path: "/register",
                    subname: "register",
                    subPath: ['register'],
                    name: "Register",
                  }
    ]
  },
  {
    path: "/users",
    element: User,
    hidden: false,
    name: "MEMBERS",
    subname: "user",
    subPath:['users','add-user','edit-user', 'student', 'add-student','edit-student', 'anonymized-users', 'debtors', 'user', 'wallet-history'],
    inactiveImage: "assets/images/users.png",
    activeImage: "assets/images/users-selected.png",
    subElements: [
                  {
                    path: "/users",
                    subPath: ['users','user', 'add-user', 'edit-user', 'wallet-history'],
                    subname: "user",
                    name: "Account Users",
                  },
                  {
                    path: "/student",
                    subname: "student",
                    subPath: ['student','add-student', 'edit-student'],
                    name: "Students",
                  },
                  {
                    path: "/debtors",
                    subname: "debtors",
                    subPath: ['debtors'],
                    name: "Outstanding Payments",
                  },
                  {
                    path: "/anonymized-users",
                    subname: "anonymized user",
                    subPath: ['anonymized-users'],
                    name: "Archived Records",
                  },
                ]
  },
  {
    path: "/teacher",
    element: Teacher,
    hidden: false,
    name: "TEAM",
    subname: "teacher",
    subPath:['teacher',"edit-teacher","add-teacher", 'earnings-by-staff','cancelled-earnings-by-staff', 'earnings-by-membership', 'sub-admin', 'add-sub-admin','edit-sub-admin'],
    inactiveImage: "assets/images/teachers.png",
    activeImage: "assets/images/teachers-selected.png",
    subElements:[
                  {
                    path: "/teacher",
                    subname: "teacher",
                    subPath:["teacher","edit-teacher","add-teacher"],
                    name: "Teachers",
                  },
                  // {
                  //   path: "/earnings-by-staff",
                  //   subname: "earning",
                  //   subPath:["earnings-by-staff","earnings-by-membership"],
                  //   name: "Earning",
                  // },
                  {
                    path: "/sub-admin",
                    subPath:["sub-admin",'add-sub-admin','edit-sub-admin'],
                    name: "Sub Admin",
                    hidden: isCompany,
                  }

    ]
  },
  {
    path: "/finance",
    element: FinanceManagement,
    hidden: false,
    name: "Finance",
    subname: "finance",
    subPath:['finance','my-earnings', 'fee-settings'],
    inactiveImage: "assets/images/payment-refund.png",
    activeImage: "assets/images/payment-refund-selected.png",
    subElements:[
                  {
                    path: "/finance",
                    subname: "finance",
                    subPath:["finance"],
                    name: "Finance Management",
                  },
                  {
                    path: "/my-earnings",
                    subname: "earning",
                    subPath:["my-earnings"],
                    name: "My Earnings",
                  },
                  {
                    path: "/fee-settings",
                    subname: "fee-settings",
                    subPath:["fee-settings"],
                    name: "Add-On Management",
                  },
                ]
  },
  {
    path: "/subscription",
    element: PlansAndAddons,
    hidden: false,
    superAdminOnly: true,
    name: "SUBSCRIPTION",
    subname: "subscription",
    subPath:['subscription', 'plans-addons'],
    inactiveImage: "assets/images/class-schedules.png",
    activeImage: "assets/images/class-schedules-selected.png",
    subElements:[
                  {
                    path: "/subscription",
                    subname: "subscription",
                    subPath:["subscription", "plans-addons"],
                    name: "Plans & Addons",
                  }
                ]
  },
  {
    path: "/subscription-success",
    element: SubscriptionSuccess,
    hidden: true,
    name: "Subscription Success",
    subname: "subscription-success",
    subPath:['subscription-success'],
  },
  {
    path: "/sms",
    element: SmsListing,
    hidden: false,
    name: "Communications",
    subname: "sms",
    subPath:['sms', 'newsletter', 'notification', 'mailing-list', 'email-templates', 'master-email-templates'],
    inactiveImage: "assets/images/newsletter.png",
    activeImage: "assets/images/newsletter-selected.png",
    subElements:[
                  {
                    path: "/sms",
                    subPath: ['sms'],
                    name: "SMS",
                  },
                  {
                    path: "/newsletter",
                    subname:"newsletter",
                    subPath: ['newsletter'],
                    name: "E-Flyer",
                  },
                  {
                    path: "/notification",
                    subname:"notification",
                    subPath: ['notification'],
                    name: "Notification",
                  },
                  {
                    path: "/mailing-list",
                    subPath: ['list'],
                    name: "Emails",
                  },
                  {
                    path: "/master-email-templates",
                    subPath: ['master-email-templates'],
                    name: "Email Templates",
                    hidden: isCompany
                  },                    
                  {
                    path: "/email-templates",
                    subPath: ['email-templates'],
                    name: "Company Email Templates",
                  }
            ]
  },
  {
    path: "/class",
    element: Class,
    hidden: false,
    name: "ORGANISATION SETUP",
    subname: "class",
    subPath:['class', 'cancelled-class', 'add-class', 'duplicate-class', 'edit-class','class-detail', 'events', 'add-event', 'edit-event','duplicate-event', 'event', 'area-code', 'school', 'edit-school', 'add-school','view-school', 'discipline', 'add-discipline', 'membership', 'add-membership','edit-membership','consents', 'add-consent', 'event-types'],
    inactiveImage: "assets/images/class-schedules.png",
    activeImage: "assets/images/class-schedules-selected.png",
    subElements:[
      {
        path: "/area-code",
        subname: "area",
        subPath: ['area-code'],
        name: "Regions",
      }, 
      {
        path: "/school",
        subname: "venue",
        subPath: ['school', 'edit-school', 'add-school', 'view-school'],
        name: "Locations",
      }, 
      {
        path: "/discipline",
        subname: "discipline",
        subPath: ['discipline', 'add-discipline'],
        name: "Activity Types",
      }, 
      {
        path: "/class",
        subname: "classes",
        subPath: ['class', 'add-class', 'class-detail', 'edit-class', 'duplicate-class'],
        name: "Sessions",
      },
      {
        path: "/membership",
        subname: "membership",
        subPath: ['membership','add-membership'],
        name: "Membership Settings",
      }, 
      {
        path: "/events",
        subname: "events",
        subPath: ['events', 'add-event', 'edit-event', 'duplicate-event'],
        name: "Special Events",
      }, 
      {
        path: "/event-types",
        subname: "event_Type",
        subPath: ['event-types', 'add-event-type'],
        name: "Event Categories",
      },
       {
        path: "/consents",
        subname: "consents",
        subPath: ['consents', 'add-consent'],
        name: "Parental Consents",
      }
]
  },
  {
    path: "/users",
    element: User,
    hidden: false,
    name: "SYSTEM ADMIN",
    subname: "admin",
    subPath:['account-deletion-request', 'import-export-data','terms-and-conditions', 'user-edit-request','edit-request', 'user-consent-edit-request','change-password', 'change-email','add-sub-admin'],
    inactiveImage: "assets/images/users.png",
    activeImage: "assets/images/users-selected.png",
    subElements: [
                  {
                    path: "/import-export-data/user",
                    subname:"import_export_data",
                    subPath: ['import-export-data'],
                    name: "Imp/Export Data",
                  },    
                  {
                    path: "/edit-request",
                    subPath: ['edit-request', 'user-edit-request', 'user-consent-edit-request'],
                    name: "Edit Requests"
                  },        
                  {
                    path: "/account-deletion-request",
                    subname:"account_deletion",
                    subPath: ['account-deletion-request'],
                    name: "Account Deletion Requests",
                  },
                  
                  {
                    path: "/terms-and-conditions",
                    subPath: ['conditions'],
                    name: "T&Cs content",
                  },
                  {
                    path: "#",
                    subname: "settings",
                    subPath: ['change-email', 'password', 'change-password'],
                    name: "Settings",
                    subElements: [
                      {
                        path: "/change-email",
                        subPath: ['change-email'],
                        name: "Change Email"
                      },
                      {
                        path: "/change-password",
                        subPath: ['password'],
                        name: "Change Password"
                      }
                    ]
                  }
                ]
  },
  {
    path: "/user/:id",
    element: ViewUser,
    hidden: true,
    name: "users",
    subname: "user",
  },
  {
    path: "/company/:id",
    element: ViewCompany,
    hidden: true,
    name: "company",
    subname: "company",
  },
  {
    path: "/company/edit/:id",
    element: EditCompany,
    hidden: true,
    name: "company",
    subname: "company",
  },
  {
    path: "/debtors",
    element: Debtors,
    hidden: true,
    name: "users",
    subname: "user",
  },

  {
    path: "/add-user",
    element: Adduser,
    hidden: true,
    name: "users",
    subname: "user",
  },
  {
    path: "/edit-user/:id",
    element: Adduser,
    hidden: true,
    name: "users",
    subname: "user",
  },
  {
    path: "/wallet-history/:id",
    element: WalletHistory,
    hidden: true,
    name: "users",
    subname: "user",
  },
  {
    path: "/student",
    element: Student,
    hidden: true,
    name: "student",
    subname: "student",
  },
  {
    path: "/add-student",
    element: AddStudent,
    hidden: true,
    name: "student",
    subname: "student",
  },
  {
    path: "/student/:id",
    element: ViewStudent,
    hidden: true,
    name: "student",
    subname: "student",
  },
  {
    path: "/student-to-teacher/:id",
    element: StudentToTeacher,
    hidden: true,
    name: "student",
    subname: "student",
  },

  {
    path: "/add-teacher",
    element: AddTeacher,
    hidden: true,
    name: "teachers",
    subname: "teacher",
  },
  {
    path: "/teacher/:id",
    element: ViewTeacher,
    hidden: true,
    name: "teachers",
    subname: "teacher",
  },
  {
    path: "/edit-teacher/:id",
    element: EditTeacher,
    hidden: true,
    name: "teachers",
    subname: "teacher",
  },
  {
    path: "/area-code",
    element: AreaCodeList,
    hidden: true,
    name: "Regions",
    subname: "area",
    inactiveImage: "assets/images/AreaUnselected.png",
    activeImage: "assets/images/Area.png",
  },
  {
    path: "/add/area-code",
    element: AddAreaCode,
    hidden: true,
    name: "Regions",
    subname: "area",
  },
  {
    path: "/edit/area-code/:id",
    element: AddAreaCode,
    hidden: true,
    name: "Regions",
    subname: "area",
  },
  {
    path: "/school",
    element: SchoolList,
    hidden: true,
    name: "Locations",
    subname: "school",
    activeImage: "assets/images/venue.png",
    inactiveImage: "assets/images/VenueUnselected.png",
  },
  {
    path: "/add-school",
    element: AddSchool,
    hidden: true,
    name: "Locations",
    subname: "school",
  },
  {
    path: "/edit-school/:id",
    element: AddSchool,
    hidden: true,
    name: "Locations",
    subname: "school",
  },
  {
    path: "/view-school/:id",
    element: SchoolDetail,
    hidden: true,
    name: "Locations",
    subname: "school",
  },
  {
    path: "/discipline",
    element: Discipline,
    hidden: true,
    name: "Activity Types",
    subname: "discipline",
    inactiveImage: "assets/images/disciplineMenu.png",
    activeImage: "assets/images/disciplineSelected.png",
  },
  {
    path: "/add-discipline",
    element: AddDiscipline,
    hidden: true,
    name: "Activity Types",
    subname: "discipline",
  },
  {
    path: "/edit/discipline/:id",
    element: AddDiscipline,
    hidden: true,
    name: "Activity Types",
    subname: "discipline",
  },
  {
    path: "/event-bookings",
    element: EventBooking,
    requireEvents: true,
    hidden: true,
    name: "event-bookings",
    subname: "booking",
  },
  {
    path: "/event-types",
    element: EventTypes,
    requireEvents: true,
    hidden: true,
    name: "Event Categories",
    subname: "types",
    inactiveImage: "assets/images/event-calender.png",
    activeImage: "assets/images/event-calender-selected.png",
  },

  {
    path: "/add-event-type",
    element: AddEventType,
    requireEvents: true,
    hidden: true,
    name: "Event Categories",
    subname: "types",
  },
  {
    path: "/edit/event-type/:id",
    element: AddEventType,
    requireEvents: true,
    hidden: true,
    name: "Event Categories",
    subname: "types",
  },
  {
    path: "/events",
    element: Events,
    requireEvents: true,
    hidden: true,
    name: "Special Events",
    subname: "event",
    inactiveImage: "assets/images/event-calender.png",
    activeImage: "assets/images/event-calender-selected.png",
  },
  {
    path: "/add-event",
    element: AddEvent,
    requireEvents: true,
    hidden: true,
    name: "Special Events",
    subname: "event",
  },
  {
    path: "/duplicate-event/:id",
    element: AddEvent,
    requireEvents: true,
    hidden: true,
    name: "Special Events",
    subname: "event",
  },
  {
    path: "/edit-event/:id",
    element: AddEvent,
    requireEvents: true,
    hidden: true,
    name: "Special Events",
    subname: "event",
  },
  {
    path: "/event/:id",
    element: ViewEvent,
    requireEvents: true,
    hidden: true,
    name: "Special Events",
    subname: "event",
  },
  {
    path: "/sizes",
    element: Sizes,
    hidden: true,
    name: "size",
    subname: "size",
  },
  {
    path: "/add-size",
    element: AddSize,
    hidden: true,
    name: "Special Events",
    subname: "event",
  },
  {
    path: "/edit-size/:id",
    element: AddSize,
    hidden: true,
    name: "Special Events",
    subname: "event",
  },
  {
    path: "/membership",
    element: Membership,
    requireMembership: true,
    hidden: true,
    name: "Membership Settings",
    subname: "membership",
    inactiveImage: "assets/images/memberships.png",
    activeImage: "assets/images/memberships-selected.png",
  },
  {
    path: "/membership/:id",
    element: ViewMembership,
    requireMembership: true,
    name: "memberships",
    subname: "membership",
    hidden: true,
  },

  {
    path: "/add-membership",
    element: AddMembership,
    requireMembership: true,
    hidden: true,
    name: "memberships",
    subname: "membership",
  },
  {
    path: "/edit-membership/:id",
    element: AddMembership,
    requireMembership: true,
    hidden: true,
    name: "memberships",
    subname: "membership",
  },
  {
    path: "/class/inactive",
    element: InactiveClass,
    hidden: true,
    name: "Sessions",
    subname: "class",
    inactiveImage: "assets/images/class-schedules.png",
    activeImage: "assets/images/class-schedules-selected.png",
  },
  {
    path: "/cancelled-class",
    element: CancelledClass,
    hidden: true,
    name: "Sessions",
    subname: "class",
    inactiveImage: "assets/images/class-schedules.png",
    activeImage: "assets/images/class-schedules-selected.png",
  },
  {
    path: "/add-class",
    element: AddClass,
    hidden: true,
    name: "Sessions",
    subname: "class",
  },
  {
    path: "/duplicate-class/:sid/:id",
    element: AddClass,
    hidden: true,
    name: "Sessions",
    subname: "class",
  },
  {
    path: "/edit-class/:sid/:id",
    element: AddClass,
    hidden: true,
    name: "Sessions",
    subname: "class",
  },
  {
    path: "/class-detail/:id",
    element: ClassDetail,
    hidden: true,
    name: "Sessions",
    subname: "class",
  },
  {
    path: "/register",
    element: Register,
    hidden: true,
    name: "register",
    inactiveImage: "assets/images/register.png",
    activeImage: "assets/images/register-selected.png",
    subname: "register",
  },
  {
    path: "/register/:id",
    element: ViewRegister,
    hidden: true,
    name: "register",
    subname: "register",
  },
  {
    path: "/add-register",
    element: AddRegister,
    hidden: true,
    name: "register",
    subname: "register",
  },
  {
    path: "/edit-register/:id",
    element: EditRegister,
    hidden: true,
    name: "Register",
    subname: "register",
  },
  {
    path: "/booking/:id",
    element: BookingDetail,
    hidden: true,
    name: "Bookings",
    subname: "booking",
  },
  {
    path: "/event-booking/:id",
    element: BookingDetail,
    hidden: true,
    name: "Bookings",
    subname: "booking",
  },
  {
    path: "/earnings-by-staff",
    element: EarningByTeacher,
    hidden: true,
    name: "Earnings",
    subname: "earning",
    inactiveImage: "assets/images/payment-refund.png",
    activeImage: "assets/images/payment-refund-selected.png",
  },
  {
    path: "/account-deletion-request",
    element: AccountDeletion,
    hidden: true,
    name: "account & deletion request",
    subname: "deletion",
    inactiveImage: "assets/images/account-deletion-request.png",
    activeImage: "assets/images/account-deletion-request-selected.png",
  },
  {
    path: "/anonymized-users",
    element: AnonymizedUser,
    hidden: true,
    name: "Anonymized Users",
    subname: "deletion",
    inactiveImage: "assets/images/account-deletion-request.png",
    activeImage: "assets/images/account-deletion-request-selected.png",
  },
  {
    path: "/view-account-deletion/:id",
    element: ViewAccountDeletion,
    hidden: true,
    name: "deletion",
    subname: "deletion",
  },
  {
    path: "/import-export-data/user",
    element: ImportExportUser,
    hidden: true,
    name: "Data Import / Export",
    subname: "export",
    inactiveImage: "assets/images/import-export-data.png",
    activeImage: "assets/images/import-export-data-selected.png",
  },
  {
    path: "/import-export-data/student",
    element: ImportExportStudent,
    hidden: true,
    name: "Data Import / Export",
    subname: "export",
    inactiveImage: "assets/images/import-export-data.png",
    activeImage: "assets/images/import-export-data-selected.png",
  },
  {
    path: "/import-export-data/requests",
    element: ImportExportRequest,
    hidden: true,
    name: "Export Requests",
    subname: "requests",
    inactiveImage: "assets/images/import-export-data.png",
    activeImage: "assets/images/import-export-data-selected.png",
  },
  {
    path: "/import-export-data/logs",
    element: ImportExportLogs,
    hidden: true,
    name: "Import/Export Logs",
    subname: "logs",
    inactiveImage: "assets/images/import-export-data.png",
    activeImage: "assets/images/import-export-data-selected.png",
  },
  {
    path: "/import-export-data/:id",
    element: ViewImportExport,
    hidden: true,
    name: "Data Import / Export",
    subname: "export",
  },

  {
    path: "/earnings-by-staff/:id",
    element: TeacherEarningDetails,
    hidden: true,
    name: "earning",
    subname: "earning",
    inactiveImage: "assets/images/payment-refund.png",
    activeImage: "assets/images/payment-refund-selected.png",
  },
  {
    path: "/finance",
    element: FinanceManagement,
    hidden: true,
    name: "finance",
    subname: "finance",
    inactiveImage: "assets/images/payment-refund.png",
    activeImage: "assets/images/payment-refund-selected.png",
  },
  {
    path: "/my-earnings",
    element: TeacherEarning,
    hidden: true,
    name: "finance",
    subname: "my-earnings",
    inactiveImage: "assets/images/payment-refund.png",
    activeImage: "assets/images/payment-refund-selected.png",
  },
   {
    path: "/fee-settings",
    element: FeeSettings,
    hidden: true,
    name: "finance",
    subname: "fee-settings",
    inactiveImage: "assets/images/payment-refund.png",
    activeImage: "assets/images/payment-refund-selected.png",
  },
  {
    path: "/earnings-by-staff-detail/:id",
    element: TeacherEarningStudentDetails,
    hidden: true,
    name: "earning",
    subname: "earning",
    inactiveImage: "assets/images/payment-refund.png",
    activeImage: "assets/images/payment-refund-selected.png",
  },
  {
    path: "/cancelled-earnings-by-staff/:id",
    element: CancelledEarning,
    hidden: true,
    name: "earning",
    subname: "earning",
    inactiveImage: "assets/images/payment-refund.png",
    activeImage: "assets/images/payment-refund-selected.png",
  },
  {
    path: "/earnings-by-membership",
    element: EarningByMembership,
    hidden: true,
    name: "earning",
    subname: "earning",
  },
  {
    path: "/refund",
    element: Refund,
    hidden: true,
    name: "earning",
    subname: "refund",
  },
  {
    path: "/add/payment-detail",
    element: AddPaymentDetail,
    hidden: true,
    name: "earning",
    subname: "payment",
  },
  {
    path: "/add/account",
    element: AddAccount,
    hidden: true,
    name: "earning",
    subname: "payment",
  },
  {
    path: "/mailing-list",
    element: MailingList,
    hidden: true,
    name: "Subscribed User",
    subname: "mailing",
    inactiveImage: "assets/images/users.png",
    activeImage: "assets/images/users-selected.png",
  },
  {
    path: "/sms/:id",
    element: SmsDetails,
    hidden: true,
    name: "Communications",
    subname: "sms",
    inactiveImage: "assets/images/users.png",
    activeImage: "assets/images/users-selected.png",
  },
  {
    path: "/add/sms",
    element: AddSMS,
    hidden: true,
    name: "Communications",
    subname: "sms",
    inactiveImage: "assets/images/users.png",
    activeImage: "assets/images/users-selected.png",
  },
  {
    path: "/edit/sms/:id",
    element: AddSMS,
    hidden: true,
    name: "Communications",
    subname: "sms",
    inactiveImage: "assets/images/users.png",
    activeImage: "assets/images/users-selected.png",
  },{
    path: "/master-email-templates",
    element: EditMasterTemplate,
    hidden: true,
    name: "EmailTemplate",
    subname: "master-email-templates",
    inactiveImage: "assets/images/newsletter.png",
    activeImage: "assets/images/newsletter-selected.png",
  },
  {
    path: "/email-templates",
    element: EditTemplate,
    hidden: true,
    name: "Eflyer",
    subname: "email-templates",
    inactiveImage: "assets/images/newsletter.png",
    activeImage: "assets/images/newsletter-selected.png",
  },
  {
    path: "/newsletter",
    element: NewsLetter,
    hidden: true,
    name: "Eflyer",
    subname: "newsletter",
    inactiveImage: "assets/images/newsletter.png",
    activeImage: "assets/images/newsletter-selected.png",
  },
  {
    path: "/newsletter/:id",
    element: NewsletterDetail,
    hidden: true,
    name: "newsletter",
    subname: "newsletter",
    inactiveImage: "assets/images/newsletter.png",
    activeImage: "assets/images/newsletter-selected.png",
  },
  {
    path: "/add/newsletter",
    element: AddNewsletter,
    hidden: true,
    name: "newsletter",
    subname: "newsletter",
    inactiveImage: "assets/images/newsletter.png",
    activeImage: "assets/images/newsletter-selected.png",
  },
  {
    path: "/edit/newsletter/:id",
    element: AddNewsletter,
    hidden: true,
    name: "newsletter",
    subname: "newsletter",
    inactiveImage: "assets/images/newsletter.png",
    activeImage: "assets/images/newsletter-selected.png",
  },
  // {
  //   path: "/grading-downloads",
  //   element: null,
  //   hidden: false,
  //   name: "grading",
  //   subname: "grading",
  //   inactiveImage: "assets/images/grading-downloads.png",
  //   activeImage: "assets/images/grading-downloads-selected.png",
  // },
  // {
  //   path: "/events",
  //   element: null,
  //   hidden: false,
  //   name: "event",
  //   subname: "event",
  //   inactiveImage: "assets/images/events.png",
  //   activeImage: "assets/images/events-selected.png",
  // },
  {
    path: "/consents",
    element: Consent,
    hidden: true,
    name: "Parental Consents",
    subname: "consents",
    inactiveImage: "assets/images/payment-refund.png",
    activeImage: "assets/images/payment-refund-selected.png",
  },
  {
    path: "/add-consent",
    element: AddConsent,
    hidden: true,
    name: "Parental Consents",
    subname: "consents",
    inactiveImage: "assets/images/payment-refund.png",
    activeImage: "assets/images/payment-refund-selected.png",
  },
  {
    path: "/edit/consent/:id",
    element: EditConsent,
    hidden: true,
    name: "Parental Consents",
    subname: "consents",
    inactiveImage: "assets/images/payment-refund.png",
    activeImage: "assets/images/payment-refund-selected.png",
  },
  {
    path: "/notification",
    element: null,
    hidden: true,
    name: "notification",
    subname: "notification",
    inactiveImage: "assets/images/notification.png",
    activeImage: "assets/images/notification-selected.png",
  },
  {
    path: "/sub-admin",
    element: ManageSubAdmin,
    hidden: true,
    name: "sub-admin",
    subname: "sub-admin",
    inactiveImage: "assets/images/users.png",
    activeImage: "assets/images/users-selected.png",
  },
  {
    path: "/sub-admin/:id",
    element: ViewSubadmin,
    hidden: true,
    name: "sub-admin",
    subname: "user",
  },

  {
    path: "/add-sub-admin",
    element: AddSubadmin,
    hidden: true,
    name: "sub-admin",
    subname: "sub-admin",
  },
  {
    path: "/edit-sub-admin/:id",
    element: AddSubadmin,
    hidden: true,
    name: "sub-admin",
    subname: "sub-admin",
  },
  {
    path: "/edit-request",
    element: EditRequest,
    hidden: true,
    name: "edit request",
    subname: "edit-request",
    inactiveImage: "assets/images/tncUnselected.png",
    activeImage: "assets/images/tncSelected.png",
  },
  {
    path: "/user-edit-request",
    element: EditUserRequest,
    hidden: true,
    name: "edit request",
    subname: "edit-request",
    inactiveImage: "assets/images/tncUnselected.png",
    activeImage: "assets/images/tncSelected.png",
  },
  {
    path: "/user-consent-edit-request",
    element: EditUserConsentRequest,
    hidden: true,
    name: "edit request",
    subname: "edit-request",
    inactiveImage: "assets/images/tncUnselected.png",
    activeImage: "assets/images/tncSelected.png",
  },
  {
    path: "/change-password",
    element: ChangePassword,
    hidden: true,
    name: "change-password",
    subname: "change-password",
  },
  {
    path: "/change-email",
    element: ChangeEmail,
    hidden: true,
    name: "change-email",
    subname: "change-email",
  },
  {
    path: "/settings",
    element: Settings,
    hidden: true,
    name: "settings",
    subname: "settings",
  },
  {
    path: "/edit-student/:id",
    element: EditStudent,
    hidden: true,
    name: "change-password",
    subname: "change-password",
  },
  {
    path: "/user/:id/wallet/:amt",
    element: Wallet,
    hidden: true,
    name: "change-password",
    subname: "change-password",
  },
  {
    path: "/terms-and-conditions",
    element: TNCList,
    hidden: true,
    name: "terms and conditions",
    subname: "terms-and-conditions",
    inactiveImage: "assets/images/tncUnselected.png",
    activeImage: "assets/images/tncSelected.png",
  },
  {
    path: "/add/terms-and-conditions",
    element: AddTnc,
    hidden: true,
    name: "Terms and Conditions",
    subname: "Terms and Conditions",
    inactiveImage: "assets/images/tncUnselected.png",
    activeImage: "assets/images/tncSelected.png",
  },
  {
    path: "/edit/terms-and-conditions/:id",
    element: AddTnc,
    hidden: true,
    name: "terms-and-conditions",
    subname: "terms-and-conditions",
    inactiveImage: "assets/images/tncUnselected.png",
    activeImage: "assets/images/tncSelected.png",
  },
  {
    path: "/registered-members/:id/:name",
    element: AllStudentListings,
    hidden: true,
    name: "register",
    subname: "register",
  },
  {
    path: "/subscription",
    element: PlansAndAddons,
    hidden: true,
    name: "subscription",
    subname: "subscription",
  },
];

export default Routers;

export function RenderRoutes({ routers }) {
  const location = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  function clearConsole() {
    if (window.console || window.console.firebug) {
      console.clear();
    }
  }

  // useEffect(() => {
  //   if (location.pathname) {
  //     clearConsole();
  //   }
  // }, [location.pathname]);
  return (
    <>
      <AnimatePresence exitBeforeEnter>
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Login />} />

          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/otp/:email" element={<OtpVerification />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Special route for subscription success - accessible without subscription guard */}
          <Route
            path="/subscription-success"
            element={
              <PrivateRoute>
                <div className="admin-panel">
                  <div className="container-fluid">
                    <div className="row no-gutters">
                      <Sidebar />
                      <SubscriptionSuccess />
                    </div>
                  </div>
                </div>
              </PrivateRoute>
            }
          />

          {routers.filter(route => route.path !== "/subscription-success").map((route, i) => {
            return (
              <Route
                key={i}
                path={route.path}
                element={
                  <PrivateRoute>
                    <ProtectedRoute 
                      requireEvents={route.requireEvents} 
                      requireMembership={route.requireMembership}
                      superAdminOnly={route.superAdminOnly}
                    >
                      <SubscriptionGuard>
                        <div className="admin-panel">
                          <div className="container-fluid">
                            <div className="row no-gutters">
                              {location.pathname !== "/404" && <Sidebar />}
                              {route?.element && <route.element />}
                            </div>
                          </div>
                        </div>
                      </SubscriptionGuard>
                    </ProtectedRoute>
                  </PrivateRoute>
                }
              ></Route>
            );
          })}
        </Routes>
      </AnimatePresence>
    </>
  );
}
